import { ApolloProvider } from '@apollo/client'
import { Navigate, Outlet, useParams } from 'react-router-dom'

import { apolloOpponent } from './apollo-opponent'
import { getOpponentKey, setOpponentKey } from './opponent-auth-state'

/**
 * Mirrors the `:opponentKey` route param into localStorage (synchronously
 * during render, so the first Apollo request carries the header) and wraps
 * the Beat-the-Pro routes in the opponent-key Apollo provider. Mirrors
 * PlayerKeyLoader; clears the cache on key change so one pro's audience view
 * can't flash under another's link.
 */
const OpponentKeyLoader = () => {
  const { opponentKey } = useParams<{ opponentKey: string }>()

  if (!opponentKey) return <Navigate to="/" replace />

  if (getOpponentKey() !== opponentKey) {
    setOpponentKey(opponentKey)
    apolloOpponent.clearStore().catch(() => {
      /* rejects if a query is mid-flight; harmless, the next render refetches */
    })
  }

  return (
    <ApolloProvider client={apolloOpponent}>
      <Outlet />
    </ApolloProvider>
  )
}

export default OpponentKeyLoader
